export default __webpack_public_path__ + "static/media/client.2f6d5048.png";